import { Reading } from "../data-models/reading";

export function sortReadingsByDateTime(readings: Reading[]): Reading[] {
  const sortedReadings = [...readings];
  sortedReadings.sort((a, b) => a.time?.localeCompare(b?.time));
  sortedReadings.sort((a, b) => a.date.localeCompare(b.date));

  return sortedReadings;
}
